import React from 'react';
import { Shield, Target, Lightbulb } from 'lucide-react';

const TeamSection = () => {
  return (
    <section className="py-12 px-4 sm:px-6 lg:px-16 bg-gradient-to-b from-white to-gray-50">
      {/* Section Header */}
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold mb-3 text-[#741112]">Our Visionaries</h2>
        <p className="text-gray-600 max-w-2xl mx-auto text-sm md:text-base">
          Driving real estate innovation with passion and expertise.
        </p>
      </div>

      {/* Team Grid with NO GAP */}
      <div className="grid lg:grid-cols-2 max-w-6xl mx-auto justify-center">
        
        {/* Member 1 */}
        <div className="bg-white p-6 rounded-xl shadow hover:shadow-xl transition border border-gray-200 text-center w-full max-w-[420px] mx-auto">
          <div className="mb-4">
            <img
              src="assets/sir-01.jpg"
              alt="Subhransu Biswal"
              className="mx-auto w-[400px] h-[400px] rounded-lg object-cover"
            />
          </div>
          <h3 className="text-xl font-semibold mb-1 text-gray-900">
            Subhransu Biswal
          </h3>
          <div className="inline-flex items-center justify-center bg-[#741112]/10 rounded px-2 py-1 text-[#741112] text-sm mb-3">
            <Target className="h-4 w-4 mr-2" />
            Co-Founder & Director
          </div>
          <p className="text-gray-600 text-sm">
            A seasoned entrepreneur with two decades of experience in technology, sales, and entrepreneurship. Expert in strategic planning, execution, leadership, and team management. He focuses primarily on financial operations and strategic execution at REALATION.
          </p>
        </div>

        {/* Member 2 */}
        <div className="bg-white p-6 rounded-xl shadow hover:shadow-xl transition border border-gray-200 text-center w-full max-w-[420px] mx-auto">
          <div className="mb-4">
            <img
              src="assets/sir-02.jpg"
              alt="Suhaan Khan"
              className="mx-auto w-[400px] h-[400px] rounded-lg object-cover"
            />
          </div>
          <h3 className="text-xl font-semibold mb-1 text-gray-900">
            Suhaan Khan (Asfer)
          </h3>
          <div className="inline-flex items-center justify-center bg-[#741112]/10 rounded px-2 py-1 text-[#741112] text-sm mb-3">
            <Lightbulb className="h-4 w-4 mr-2" />
            Co-Founder & Director
          </div>
          <p className="text-gray-600 text-sm">
            Graduate from one of India's prominent B-schools with specialization in marketing. Entered real estate fueled by passion for innovation and excellence. With over 10 years of experience, he focuses on business development and marketing strategy at REALATION.
          </p>
        </div>

      </div>
    </section>
  );
};

export default TeamSection;
